import React from "react";

export default function TagList(props) {

  return (
    <ul className="fk-table__list">
      {props.children}
    </ul>
  );
}